import { glass, LandingSection, Reveal } from "@/components/landing/reveal";

const STEPS = [
  {
    num: "01",
    title: "Import",
    body: "Upload a KiCad zip or connect git. Hardware SoT stays in the repo — Mission never becomes a second schematic editor.",
  },
  {
    num: "02",
    title: "Review",
    body: "Open a Design Review on from_ref ↔ to_ref. circuit_diff lands a pin-pair table and sheet preview on the change.",
  },
  {
    num: "03",
    title: "Issues",
    body: "Findings become issues on the git ref. Comments hang on path / sheet / refdes — not a floating ticket board.",
  },
  {
    num: "04",
    title: "Track",
    body: "Guide → Track until the board is flight-ready. Jobs drain import, checks, and circuit_diff in the open.",
  },
] as const;

export function LandingHow() {
  return (
    <LandingSection
      id="how"
      eyebrow="How it works"
      title="Import → review → issues → track."
      lede="A short loop teams already know from GitHub — wired for hardware."
    >
      <ol className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} as="li" delay={0.05 * i} className={`${glass} flex h-full flex-col p-5`}>
            <p className="mb-4 font-mono text-[11px] tracking-[0.14em] text-falcon">{step.num}</p>
            <h3 className="mb-2 text-[16px] font-semibold text-white">{step.title}</h3>
            <p className="m-0 text-[14px] leading-[1.55] text-white/64">{step.body}</p>
          </Reveal>
        ))}
      </ol>
    </LandingSection>
  );
}
